import { useEffect, useRef, useCallback } from 'react';

const API = process.env.REACT_APP_API_BASE_URL || 'http://169.58.21.41/api';

// Connects to SSE stream for a field and calls handlers on events.
// Falls back to polling if SSE is unavailable.
export default function useIrrigationStream(fieldId, { onRelay, onMode, onDssResult, onInit } = {}) {
    const esRef = useRef(null);
    const token = localStorage.getItem('auth_token');

    const connect = useCallback(() => {
        if (!fieldId || !token) return;
        if (esRef.current) { esRef.current.close(); esRef.current = null; }

        // EventSource doesn't support custom headers — pass token as query param
        const url = `${API}/irrigation/${fieldId}/stream?token=${encodeURIComponent(token)}`;
        const es = new EventSource(url);
        esRef.current = es;

        es.addEventListener('init', (e) => {
            try { onInit?.(JSON.parse(e.data)); } catch (_) {}
        });
        es.addEventListener('relay', (e) => {
            try { onRelay?.(JSON.parse(e.data)); } catch (_) {}
        });
        es.addEventListener('mode', (e) => {
            try { onMode?.(JSON.parse(e.data)); } catch (_) {}
        });
        es.addEventListener('dss_result', (e) => {
            try { onDssResult?.(JSON.parse(e.data)); } catch (_) {}
        });

        es.onerror = () => {
            es.close();
            esRef.current = null;
            // Reconnect after 5s
            setTimeout(connect, 5000);
        };
    }, [fieldId, token]);

    useEffect(() => {
        connect();
        return () => { esRef.current?.close(); esRef.current = null; };
    }, [connect]);
}
